import {
  ActionIcon,
  createStyles,
  Group,
  Skeleton,
  Stack,
  Text,
} from '@mantine/core';
import React from 'react';

import { useConfig, usePortalConfig } from '@portals/api/partners';
import { ReactComponent as ArrowLeft } from '@portals/icons/linear/arrow-left.svg';
import { TenantType } from '@portals/types';

export function SidebarMock() {
  const { classes } = useStyles();
  const config = useConfig();
  const portalConfig = usePortalConfig();

  return (
    <div className={classes.container}>
      <Group className={classes.header}>
        <img
          width={30}
          height={30}
          alt="logo"
          src={
            config?.data?.[TenantType.Partner]?.logo_url ||
            portalConfig?.data?.design?.navigation_menu?.logo ||
            portalConfig?.data?.design?.sign_in_page?.logo ||
            'logo_full_dark.svg'
          }
        />

        <Text weight={700}>{config.data?.partner?.display_name}</Text>
      </Group>

      <Stack spacing="xl">
        <SidebarSection />

        <SidebarSection active />

        <SidebarSection />
      </Stack>

      <Group position="right" className={classes.footer}>
        <ActionIcon color="blue_gray">
          <ArrowLeft width={15} height={15} />
        </ActionIcon>
      </Group>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'max-content 1fr max-content',
    paddingInline: theme.spacing.xs,
    borderRight: `2px solid ${theme.colors.gray[2]}`,
  },
  header: {
    paddingBlock: theme.spacing.sm,
  },
  footer: {
    paddingBlock: theme.spacing.sm,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
  },
}));

function SidebarSection({ active = false }: { active?: boolean }) {
  const { classes, cx } = useSidebarSectionStyles();

  return (
    <div>
      <Skeleton width={65} height={8} animate={false} />
      <Group spacing="xs" py="xs">
        <Skeleton width={20} height={20} circle animate={false} />
        <Skeleton width={78} height={8} animate={false} />
      </Group>
      <Group
        spacing="xs"
        py="xs"
        className={cx({ [classes.activeItem]: active })}
      >
        <Skeleton
          width={20}
          height={20}
          circle
          animate={false}
          className={cx({ [classes.activeSkeleton]: active })}
        />
        <Skeleton
          width={57}
          height={8}
          animate={false}
          className={cx({ [classes.activeSkeleton]: active })}
        />
      </Group>
      <Group spacing="xs" py="xs">
        <Skeleton width={20} height={20} circle animate={false} />
        <Skeleton width={72} height={8} animate={false} />
      </Group>
    </div>
  );
}

const useSidebarSectionStyles = createStyles((theme) => ({
  activeItem: {
    paddingInlineStart: theme.spacing.md,
    borderRadius: theme.radius.md,
    backgroundColor: theme.fn.primaryColor(),
  },
  activeSkeleton: {
    '&:after': {
      backgroundColor: theme.white,
    },
  },
}));
